<template>
    <div id="contacto" class="contact">
        <b-container>
            <b-row>
                <b-col lg="6" style="position: relative;">
                    <img class="spark1" src="../assets/img/spark1.png" alt="Spark">
                    <h2 class="mb-4">Deja tus <br> comentarios</h2>
                    <img class="spark2" src="../assets/img/sparks2.png" alt="Spark">
                    <p class="mb-4">Aprende en Espacio Kokolet y disfruta <br> de cursos que te harán divertir</p>
                    <img class="mb-5" src="../assets/img/imgcomentarios.png" alt="Image contact">
                </b-col>
                <b-col class="mb-4" lg="6">
                    <b-form>
                        <b-form-group>
                            <div style="display: none;">
                                <b-form-input
                                    id="honeypot"
                                    v-model="honeypot"
                                    placeholder=" "
                                ></b-form-input>
                            </div>
                        </b-form-group>
                        
                        <p v-if="messageSend">{{messageSend}}</p>
                        <b-form-group id="input-group-1">
                            <div class="align-items-center">
                                <b-form-input
                                    id="input-1"
                                    v-model="nombre"
                                    placeholder="Nombre:"
                                    required
                                ></b-form-input>
                            </div>
                        </b-form-group>
                    
                        <b-form-group id="input-group-6">
                            <div class="form-floating">
                                <b-form-input
                                    id="input-6"
                                    v-model="correo"
                                    placeholder="Email:"
                                    required
                                ></b-form-input>
                            </div>
                        </b-form-group>
                    
                        <b-form-group id="input-group-7">
                            <div class="texta">
                                <b-form-textarea
                                    id="input-7"
                                    v-model="mensaje"
                                    placeholder="Mensaje:"
                                    rows="2"
                                    max-rows="4"
                                    style="overflow:hidden"
                                ></b-form-textarea>
                            </div>
                        </b-form-group>
                            

                        <b-button class="boton enviar mt-3" v-on:click="sendMessage">Enviar</b-button>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="4">
                    <img src="../assets/img/logo.svg" alt="Logo contact">
                </b-col>
                <b-col md="4">
                    <p class="mb-0"><strong>¿Tienes alguna duda?</strong></p>
                    <p>Llámanos al +52 1 55 4928 7238</p>
                    <p class="socials">
                        <a href="https://www.facebook.com/Kokolet.mx" target="_blank"><img src="../assets/img/fbwhite.png" alt=""></a>
                        <a href="https://www.instagram.com/kokolet.mx/" target="_blank"><img src="../assets/img/igwhite.png" alt=""></a>
                        <a href="https://api.whatsapp.com/send/?phone=525549287238&amp;app_absent=0"  target="_blank"><img src="../assets/img/whapwhite.png" alt=""></a>
                        <a href="https://www.tiktok.com/@kokoletmx" target="_blank"><img src="../assets/img/tiktokwhite.png" alt=""></a>
                    </p>
                </b-col>
                <b-col md="4">
                    <p class="mb-0"><strong>Ubícanos</strong></p>
                    <p class="text-p"><img src="../assets/img/ubi.png"> Laguna 35, Ampliacion Los Alpes, Álvaro Obregón, 01710 Ciudad de México, CDMX</p>
                    <p class="text-p"><img src="../assets/img/correo.png"> ram@kokolet.com.mx</p>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import axios from 'axios'
    export default {
        data() {
            return {
                nombre: '',
                correo: '',
                mensaje: '',
                honeypot: '',
                messageSend: ''
            };
        },
        methods: {
            async sendMessage() {
                if (this.honeypot) {
                    return;
                }

                if (this.nombre !== '' && this.mensaje !== '' && this.correo !== '') {
                try {
                    const response = await axios.post('vendor/send-mail.php', {
                        nombre: this.nombre,
                        correo: this.correo,
                        mensaje: this.mensaje
                    });

                    if (response.data == 200 || response.data == '200') {
                        this.messageSend = 'Mensaje enviado exitosamente.';
                        this.nombre = ""
                        this.correo = ""
                        this.mensaje = ""
                    } else {
                        this.messageSend = 'Error al enviar mensaje, intenta más tarde.';
                    }
                } catch (error) {
                    console.error(error);
                    this.messageSend = 'Error al enviar mensaje, intenta más tarde.';
                }
                } else {
                    this.messageSend = 'Ingresa la información necesaria en los campos.';
                }
            }
        },
    }
</script>

<style scoped>
.contact{
    background: #5D867C;
    color: #fff;
    text-align: left;
    border-top-left-radius: 50px;
    border-top-right-radius: 50px;
    padding: 7% 0 3% 0;
}
.spark1{
    /* position: absolute; */
    margin-left: -30px;
}
.spark2{
    position: absolute;
    left: 370px;
    margin-top: -100px;
}
h2{
    font-size: 50px;
}
p{
    font-size: 20px;
}
.socials{
    margin-top: 20px;
}
.socials a{
    margin-right: 20px;
}

.form-control{
    border: none;
    max-width: 458.67px;
    border-radius: 15px !important;
    font-size: 20px;
    color: #5D867C;
    padding-top: 15px;
    padding-bottom: 15px;
    height: auto;
    -webkit-appearance:none;
}
.btn{
    max-width: 457.67px;
    height: 72px;
    gap: 0px;
    border-radius: 10px;
    font-size: 20px;
    background: #EEBBAE !important;
    width: 100%;
    border: none;
}
::placeholder{
    color: #5D867C;

}
textarea{
    border-radius: 15px !important;
    -webkit-appearance:none;
}
.text-p{
    padding-left: 20px;
    position: relative;
}

.text-p img{
    position: absolute;
    left: 0;
    top: 9px;
}
@media (max-width: 992px){
    .contact{
        padding: 10% 20px;
    }
    .spark1{
        margin-left: -10px;
        width: 20px;
    }
    .spark2{
        position: absolute;
        left: 260px;
        width: 45px;
        margin-top: -100px;
    }
    h2{
        font-size: 37px;
    }
    p{
        font-size: 18px;
    }
}
</style>